import React from 'react'
import ReactMarkdown from 'react-markdown'
import remarkGfm from 'remark-gfm'
import rehypeRaw from 'rehype-raw'
import styled from 'styled-components'
import { Layout } from '../components'
import { CodeBlock } from '../components/highlight'

const TemplateCss = styled.div`
  width: 100%;
  table,
  tr,
  td,
  th {
    border: 1px solid #aaaaaa;
    padding: 5px 10px;
    text-align: left;
  }
  pre {
    background: #f4f4f4;
  }
  a {
    color: #f2063f;
  }
  img {
    max-width: 100%;
    box-shadow: 1px 1px 10px 2px #aaa;
    margin: 20px 0;
  }
  p {
    margin: 5px 0;
  }
  h1 {
    margin: 10px 0 0 0;
    font-size: 30px;
    font-weight: 400;
  }
`

const TimeP = styled.p`
  font-size: 12px;
  color: #666;
  line-height: 20px;
  margin-bottom: 20px !important;
`

const PostPage = ({
  pageContext: { title, titleEn, updateTime, content, contentEn, headNavLinkObj },
}) => {
  const getDates = (updateTime) => {
    const date = new Date(updateTime)
    return (
      `${date.getFullYear()}-` +
      `${date.getMonth() + 1}`.padStart(2, '0') +
      `-` +
      `${date.getDate()}`.padStart(2, '0') +
      ` ` +
      `${date.getHours()}`.padStart(2, '0') +
      `:` +
      `${date.getMinutes()}`.padStart(2, '0') +
      `:` +
      `${date.getSeconds()}`.padStart(2, '0')
    )
  }

  return (
    <Layout headNavLinkObj={headNavLinkObj}>
      <TemplateCss>
        <h1>{process.env.GATSBY_LOCALE === 'zh' ? title : titleEn}</h1>
        <TimeP>
          {process.env.GATSBY_LOCALE === 'zh' ? '最近更新时间: ' : 'Last Update Time: '}{' '}
          {updateTime && getDates(updateTime)}
        </TimeP>
        {process.env.GATSBY_LOCALE === 'zh' && (
          <ReactMarkdown
            remarkPlugins={[remarkGfm]}
            rehypePlugins={[rehypeRaw]}
            children={content}
            components={{
              code(params) {
                let language = undefined
                if (params.className) {
                  language = params.className.split('-')[1]
                }
                return <CodeBlock language={language ?? 'javascript'} value={params.children} />
              },
            }}
          />
        )}
        {process.env.GATSBY_LOCALE === 'en' && (
          <>
            {contentEn && (
              <ReactMarkdown
                remarkPlugins={[remarkGfm]}
                rehypePlugins={[rehypeRaw]}
                children={contentEn}
                components={{
                  code(params) {
                    let language = undefined
                    if (params.className) {
                      language = params.className.split('-')[1]
                    }
                    return <CodeBlock language={language ?? 'javascript'} value={params.children} />
                  },
                }}
              />
            )}
          </>
        )}
      </TemplateCss>
    </Layout>
  )
}

export default PostPage
